import React from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";

import mq from "../../../helpers/media-queries";

import Arrow from "../../../assets/img/breadcrumbs-arrow.svg";

const El = styled.ul`
    ${mq("sm", "min")} {
        margin-top: ${rem(-30)};
        margin-bottom: ${rem(30)};
    }

    ${(props) =>
        props.showMobileOnly &&
        css`
            display: none;
            ${mq("sm", "max")} {
                margin-bottom: 0;
                display: block;
                padding: ${rem(17)};
                padding-bottom: 0;
            }
        `}

    ${(props) =>
        props.hideMobile &&
        css`
            ${mq("sm", "max")} {
                display: none;
            }
        `}
`;

const BreadcrumbLink = styled.button`
    display: inline-block;
    font-size: ${rem(13)};
    font-family: Sans-serif;
    color: #5c5e62;
    padding: 0;
    appearance: none;
    border: 0;
    background: none;
    position: relative;

    &:not(:last-child) {
        padding-right: ${rem(30)};
    }

    ${(props) =>
        props.showMobileOnly &&
        css`
            padding-right: ${rem(20)};
            font-size: ${rem(10)};
        `}

    &:not(:disabled) {
        cursor: pointer;
    }

    &:not(:last-of-type) {
        &:after {
            content: "";
            width: ${rem(9)};
            height: ${rem(12)};
            position: absolute;
            right: ${rem(10)};
            top: 50%;
            margin-top: ${rem(-6)};
            background: url(${Arrow});
            background-repeat: no-repeat;
            ${(props) =>
                props.showMobileOnly &&
                css`
                    width: ${rem(9)};
                    right: ${rem(5)};
                `}
        }
    }

    ${(props) =>
        props.active &&
        css`
            color: #2d71b6;
        `}
`;

const Breadcrumbs = ({ links, showMobileOnly, hideMobile }) => (
    <El showMobileOnly={showMobileOnly} hideMobile={hideMobile}>
        {links.map((item, index) => (
            <BreadcrumbLink disabled={item.active} active={item.active} key={index}>
                {item.title}
            </BreadcrumbLink>
        ))}
    </El>
);

export default Breadcrumbs;
